/* eslint-disable @typescript-eslint/no-unused-vars */

import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedPathSegments } from '@pgaoc/shared-lib';
import { MemberAuthRepository } from '../repository/member-auth-repository';

type Activated = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({ providedIn: 'root' })
export class RefreshSessionGuard implements CanActivate {
  private memberAuthRepository = inject(MemberAuthRepository);
  private router = inject(Router);

  // Component can only be activated if there is no session (ie. Shouldn't be able to view the log in page if logged in)

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Activated {
    return this.memberAuthRepository.isAuthenticated().pipe(
      take(1),
      map(authenticatedUser => {
        return !authenticatedUser || this.router.createUrlTree([SharedPathSegments.layoutRoot()]);
      }),
    );
  }
}
